export default "__VITE_ASSET__D0yj1SBD__"